/**
 * @generated SignedSource<<e60ba00962d35bb2969965cc8df45c80>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "messageId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "messageId",
            "variableName": "messageId"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "QueuedJobStatusQuery",
            "selections": [
                {
                    "args": (v1 /*: any*/),
                    "kind": "FragmentSpread",
                    "name": "QueuedJobStatus_query"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "QueuedJobStatusQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "QueuedJob",
                    "kind": "LinkedField",
                    "name": "queuedJobByMessageId",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startTime",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endTime",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "QueuedJobAttachment",
                            "kind": "LinkedField",
                            "name": "attachments",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                },
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "096148f6cd9795624c9d308f54d4e4b1",
            "id": null,
            "metadata": {},
            "name": "QueuedJobStatusQuery",
            "operationKind": "query",
            "text": "query QueuedJobStatusQuery(\n  $messageId: String!\n) {\n  ...QueuedJobStatus_query_31kHET\n}\n\nfragment QueuedJobStatus_query_31kHET on Query {\n  queuedJobByMessageId(messageId: $messageId) {\n    id\n    status\n    startTime\n    endTime\n    attachments {\n      name\n      url\n      id\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "5ceafb7a29be73157ed7b12c415e7abf";
export default node;
